import React from "react";
import "./SignInTextContainer.scss";

const SignInTextContainer = ({ companyForm }) => {
    return (
        <div className="signin__text__container">
            <div className={`main-text ${companyForm && "company__details__mode"}`}>
                <p className="main__para">A powerful</p>
                <p className="sub__main">social media suite</p>
                <p className="secondary__text">that helps you listen, monitor and respond to online conversations easily.</p>
            </div>
        </div>
    );
};

export default SignInTextContainer;
